import { render, staticRenderFns } from "./Linkding.vue?vue&type=template&id=d384a97e&scoped=true&"
import script from "./Linkding.vue?vue&type=script&lang=js&"
export * from "./Linkding.vue?vue&type=script&lang=js&"
import style0 from "./Linkding.vue?vue&type=style&index=0&id=d384a97e&scoped=true&lang=scss&"
import style1 from "./Linkding.vue?vue&type=style&index=1&id=d384a97e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d384a97e",
  null
  
)

export default component.exports